import React, { useState } from "react";
import "../css-dashboard/Dashboard.css";
import { Link } from "react-router-dom";
import TravelAgency from "../../assets/travel-agency.svg";
import Reward from "../../assets/reward.svg";
import EmAndamento from "../../assets/em-andamento.svg";
import SidebarReceiver from "../../components/sidebar-dashboard/SidebarReceiver";
import ReceiverTripsProgressNegotiations from "../../components/receiver-trips-negotiations/ReceiverTripsProgressNegotiations";
import UseReceiverTripsNegotiations from "../../hooks/UseTripsNegotiations/UseReceiverTripsNegotiations";
import UseModalReceiverConfirmData from "../../hooks/UseModalReceiverConfirmData/UseModalReceiverConfirmData";
import ModalReceiverConfirmData from "../../components/modal-receiver-confirm-data/ModalReceiverConfirmData";
import UseModalPhotosOrder from "../../hooks/UseModalPhotosOrder/UseModalPhotosOrder";
import ModalPhotosOrder from "../../components/modal-photos-order/ModalPhotosOrder";
import UseModalChat from "../../hooks/UseModalChat/UseModalChat";
import ModalChat from "../../components/modal-chat/ModalChat";
import UseModalConfirmReceiptOrder from "../../hooks/UseModalConfirmReceiptOrder/UseModalConfirmReceiptOrder";
import ModalConfirmReceiptOrder from "../../components/modal-confirm-receipt-order/ModalConfirmReceiptOrder";

const DashboardReceiver = ({ menuOpen, setMenuOpen }) => {
  const {
    tripsNegotiations,
    loadingTripsNegotiations,
    refetchTripsNegotiations,
  } = UseReceiverTripsNegotiations();

  const {
    isOpenReceiverConfirmData,
    showSuccessScreenReceiverConfirmData,
    openModalReceiverConfirmData,
    closeModalReceiverConfirmData,
    selectedNegotiationReceiverConfirmData,
    actionTypeReceiverConfirmData,
    handleSubmit: handleSubmitReceiverConfirmData,
    loadingReceiverConfirmData,
    errorReceiverConfirmData,
    successReceiverConfirmData,
  } = UseModalReceiverConfirmData(() => {
    refetchTripsNegotiations();
  });

  const {
    isOpenPhotosOrder,
    showSuccessScreenPhotosOrder,
    selectedNegotiationPhotosOrder,
    photosPhotosOrder,
    loadingPhotosOrder,
    errorPhotosOrder,
    successPhotosOrder,

    openPhotosOrderModal,
    closePhotosOrderModal,

    handleChangePhotoOrder,
    handleSubmitPhotosOrder,
  } = UseModalPhotosOrder(() => {
    refetchTripsNegotiations();
  });

  const {
    isOpenChat,
    selectedNegotiationChat,
    currentRoleChat,
    messagesChat,
    messageChat,
    emojiList,
    setShowEmojiPickerChat,
    showEmojiPickerChat,
    handleEmojiSelect,
    loadingMessagesChat,
    sendingChat,
    errorChat,
    messagesEndRef,
    openChatModal,
    closeChatModal,
    handleMessageChange,
    handleSendMessage,
  } = UseModalChat(() => {
    refetchTripsNegotiations();
  });

  const {
    isOpenConfirmReceiptOrder,
    showSuccessScreenConfirmReceiptOrder,
    openModalConfirmReceiptOrder,
    closeModalConfirmReceiptOrder,
    selectedNegotiationConfirmReceiptOrder,
    formDataConfirmReceiptOrder,
    handleChange,
    handlePhoneChange,
    handleBlur,
    handleSubmit,
    loadingConfirmReceiptOrder,
    errorConfirmReceiptOrder,
    successConfirmReceiptOrder,
    errorsConfirmReceiptOrder,
  } = UseModalConfirmReceiptOrder(() => {
    refetchTripsNegotiations();
  });

  return (
    <>
      <div className={`dashboard-container ${menuOpen ? "menu-open" : ""}`}>
        <SidebarReceiver menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

        <main className="main-content">
          <div className="dashboard-header">
            <h1>Dashboard do Destinatário</h1>
            <p className="breadcrumb">
              <a href="/dashboard-receiver">Início</a> / Dashboard do
              Destinatário
            </p>
          </div>

          <section className="stats-grid">
            <div className="stat-card">
              <div className="dashboard-icon blue">
                <img src={Reward} alt="" />
              </div>

              <div className="stat-info">
                <span>Encomendas em Andamento</span>
                <h2 className="total-earns">
                  {
                    tripsNegotiations.filter((item) =>
                      ["4", "5", "6", "7"].includes(item.trip_status),
                    ).length
                  }
                </h2>
                <Link to="#">
                  <div className="view-details">Ver detalhes</div>
                </Link>
              </div>
            </div>

            <div className="stat-card">
              <div className="dashboard-icon teal">
                <img src={TravelAgency} alt="" />
              </div>

              <div className="stat-info">
                <span>Encomendas Recebidas</span>
                <h2>
                  {
                    tripsNegotiations.filter((item) =>
                      ["8"].includes(item.trip_status),
                    ).length
                  }
                </h2>
                <Link to="#">
                  <div className="view-details">Ver detalhes</div>
                </Link>
              </div>
            </div>

            <div className="stat-card">
              <div className="dashboard-icon orange">
                <img src={EmAndamento} alt="" />
              </div>

              <div className="stat-info">
                <span>Encomendas não Efetivadas</span>
                <h2>0</h2>
                <Link to="#">
                  <div className="view-details">Ver detalhes</div>
                </Link>
              </div>
            </div>
          </section>

          <ReceiverTripsProgressNegotiations
            tripsNegotiations={tripsNegotiations}
            loadingTripsNegotiations={loadingTripsNegotiations}
            onOpenReceiverConfirmModal={openModalReceiverConfirmData}
            onOpenPhotosOrderModal={openPhotosOrderModal}
            onOpenChatModal={openChatModal}
            onOpenModalConfirmReceiptOrder={openModalConfirmReceiptOrder}
          />
        </main>
      </div>
      <ModalReceiverConfirmData
        isOpenReceiverConfirmData={isOpenReceiverConfirmData}
        showSuccessScreenReceiverConfirmData={
          showSuccessScreenReceiverConfirmData
        }
        closeModalReceiverConfirmData={closeModalReceiverConfirmData}
        selectedNegotiationReceiverConfirmData={
          selectedNegotiationReceiverConfirmData
        }
        actionTypeReceiverConfirmData={actionTypeReceiverConfirmData}
        handleSubmit={handleSubmitReceiverConfirmData}
        loadingReceiverConfirmData={loadingReceiverConfirmData}
        errorReceiverConfirmData={errorReceiverConfirmData}
        successReceiverConfirmData={successReceiverConfirmData}
      />

      <ModalPhotosOrder
        isOpenPhotosOrder={isOpenPhotosOrder}
        closePhotosOrderModal={closePhotosOrderModal}
        showSuccessScreenPhotosOrder={showSuccessScreenPhotosOrder}
        selectedNegotiationPhotosOrder={selectedNegotiationPhotosOrder}
        photosPhotosOrder={photosPhotosOrder}
        loadingPhotosOrder={loadingPhotosOrder}
        errorPhotosOrder={errorPhotosOrder}
        successPhotosOrder={successPhotosOrder}
        modePhotosOrder="upload"
        handlePhotoChange={handleChangePhotoOrder}
        handleSubmit={handleSubmitPhotosOrder}
      />

      <ModalChat
        isOpenChat={isOpenChat}
        selectedNegotiationChat={selectedNegotiationChat}
        currentRoleChat={currentRoleChat}
        messagesChat={messagesChat}
        messageChat={messageChat}
        emojiList={emojiList}
        setShowEmojiPickerChat={setShowEmojiPickerChat}
        showEmojiPickerChat={showEmojiPickerChat}
        handleEmojiSelect={handleEmojiSelect}
        loadingMessagesChat={loadingMessagesChat}
        sendingChat={sendingChat}
        errorChat={errorChat}
        messagesEndRef={messagesEndRef}
        closeChatModal={closeChatModal}
        handleMessageChange={handleMessageChange}
        handleSendMessage={handleSendMessage}
      />

      <ModalConfirmReceiptOrder
        isOpenConfirmReceiptOrder={isOpenConfirmReceiptOrder}
        showSuccessScreenConfirmReceiptOrder={
          showSuccessScreenConfirmReceiptOrder
        }
        closeModalConfirmReceiptOrder={closeModalConfirmReceiptOrder}
        formDataConfirmReceiptOrder={formDataConfirmReceiptOrder}
        handleChange={handleChange}
        handlePhoneChange={handlePhoneChange}
        handleBlur={handleBlur}
        handleSubmit={handleSubmit}
        loadingConfirmReceiptOrder={loadingConfirmReceiptOrder}
        errorConfirmReceiptOrder={errorConfirmReceiptOrder}
        errorsConfirmReceiptOrder={errorsConfirmReceiptOrder}
        successConfirmReceiptOrder={successConfirmReceiptOrder}
        selectedNegotiationConfirmReceiptOrder={
          selectedNegotiationConfirmReceiptOrder
        }
      />
    </>
  );
};

export default DashboardReceiver;
